module.exports = __webpack_public_path__ + "static/media/moveleira.77563349.webp";